import { Trans } from '@lingui/react/macro';
import { createModal } from '@thermon-platforms/thermon-ui-core';
import { getDeviceUrl } from 'util/device';
import { useNavigate } from 'react-router-dom';
import useDevicesStore from 'store/devices';
import ReassignDeviceModal from './modal';


function ReassignDeviceButton({device}) {
  const [devicesStore, devicesStoreActions] = useDevicesStore();
  const navigate = useNavigate();

  function handleClick() {
    createModal(<ReassignDeviceModal device={device} />)
      .open()
      .then(newParentId => {
        if (!newParentId) return;
        devicesStoreActions.query();
        navigate(getDeviceUrl(devicesStore.shallowDevices.get(newParentId)));
      })
      .catch(() => {/* no-op */});
  }

  return (<div className="secondary-management-section reassign-device">
    <h3><Trans>Reassign this {device.model.type}</Trans></h3>
    <p>
      <Trans>
        If you need to move this device to a different parent, you can reassign it here.
        This will not change any of the device's settings or configurations.
      </Trans>
    </p>

    <button onClick={handleClick}>
      <Trans>Reassign</Trans>
    </button>
  </div>);
}

export default ReassignDeviceButton;
